import React from "react";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory, useLocation } from "react-router-dom";
import buildUrlParams from "components/Pager/buildUrlParams";
import addressIsValid from "helpers/addressIsValid";

function Search({ urlAddress }: { urlAddress?: string }) {
  const [value, setValue] = React.useState(urlAddress || "");
  const [err, setErr] = React.useState("");
  const { search, pathname } = useLocation();
  const history = useHistory();

  const onSearch = () => {
    if (addressIsValid(value)) {
      const { nextUrlParams } = buildUrlParams(search, {
        address: value,
      });
      history.push(`${pathname}?${nextUrlParams}`);
    } else {
      setErr("Invalid address");
    }
  };

  const onClear = () => {
    setValue("");
    setErr("");
    const { params } = buildUrlParams(search, {});

    // eslint-disable-next-line
    const { address, ...rest } = params;

    const nextUrlParams = new URLSearchParams(rest).toString();

    history.push(`${pathname}?${nextUrlParams}`);
  };

  return (
    <div className="mx-5 mx-lg-0" style={{ minWidth: "18rem" }}>
      <div className="input-group input-group-seamless">
        <input
          type="text"
          className="form-control input-dark"
          placeholder="Search"
          name="searchInput"
          value={value}
          onChange={(e) => {
            setValue(e.target.value.trim());
            setErr("");
          }}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === "Enter") {
              onSearch();
            }
          }}
          id="searchInput"
          style={{ borderRadius: "2rem" }}
          required
        />
        <div className="input-group-append">
          {value ? (
            <button
              id="resetSearch"
              className="input-group-text"
              onClick={onClear}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          ) : (
            <button id="focusSearch" className="input-group-text">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          )}
        </div>
      </div>
      {err && <span className="text-white">{err}</span>}
    </div>
  );
}

export default Search;
